import type { todayMessagesDe } from "./messages.today.de";

/** English texts of the start page „Heute“ and the compact clock of the app bar (F-75). */
export const todayMessagesEn: Readonly<Record<keyof typeof todayMessagesDe, string>> = {
  "today.balance.title": "Balance",
  "today.balance.flexitimeAccount": "Flexitime account",
  "today.balance.overtimeAccount": "Overtime account",
  "today.balance.monthActual": "Actual this month",
  "today.balance.monthTarget": "Target this month",
  "today.balance.link": "All balances",
  "today.open.title": "Open",
  "today.open.none": "Nothing open.",
  "today.open.corrections.one": "{count} own correction request awaits a decision",
  "today.open.corrections.other": "{count} own correction requests await a decision",
  "today.open.absences.one": "{count} absence request awaits a decision",
  "today.open.absences.other": "{count} absence requests await a decision",
  "today.open.attributionRequests.one": "{count} own project attribution request awaits a decision",
  "today.open.attributionRequests.other":
    "{count} own project attribution requests await a decision",
  "today.open.findings.one": "{count} finding this week",
  "today.open.findings.other": "{count} findings this week",
  "today.open.projectDays.one": "{count} day without complete project attribution",
  "today.open.projectDays.other": "{count} days without complete project attribution",
  "today.offline": "Not available without a connection. Clocking keeps working.",
  "today.failed": "Could not be loaded right now.",
  "compactClock.title": "Time clock",
  "compactClock.suffix": "– time clock",
  "compactClock.suffixWarning": "– time clock, mind the warning",
  "compactClock.summary": "{state} · {duration}",
  "compactClock.today": "Today {work} h worked, {break} h break",
  "compactClock.close": "Close time clock",
  "compactClock.confirmClockOut":
    "Clock out now and end the working day? Afterwards the end can only be changed with a correction request.",
  "compactClock.confirmClockOutAction": "Yes, clock out",
  "compactClock.overviewQuestion":
    "The day overview for the project attribution is on “Today”. This page has unsaved input that is lost when you switch.",
  "compactClock.overviewStay": "Stay here",
  "compactClock.overviewGo": "To the day overview",
  "compactClock.openStart": "To the start page “Today”",
};
